import * as React from "react";
import "./officeReturnAddress.scss";

import { cs } from "@Common/react/chain-services";

import { CustomizationTile }    from "./customizationTile";
import { LabelAndInputContent } from "./labelAndInputContent";

export const OfficeReturnAddress = ({addressData, userLevel, agentEditBranch, branchEditDisplay, formattingModal, setUnsavedChanges}) => cs(
    ["readOnlyVal", ({}, next) => next(userLevel === 5 ? !agentEditBranch : userLevel === 4 ? !parseInt(branchEditDisplay) : false)],

    ({readOnlyVal}) => (
        <CustomizationTile
            header="Office Return Address"
            formattingModal={formattingModal}
            xdQaName="Office Return Address"
        >
            <LabelAndInputContent
                data={addressData}
                readOnly={readOnlyVal}
                setUnsavedChanges={setUnsavedChanges}
            />
            { !readOnlyVal &&
            <div className="default-office-return-address">
                            <input
                                type="checkbox"
                                xd-qa-type="checkbox"
                                xd-qa-name="Save as default Office Return Address"
                                name="officeReturnAddressDefault"
                                value={1}
                            /><div className="label">Save as default Office Return Address</div>
            </div>}
        </CustomizationTile>
    )
);
